export default __webpack_public_path__ + "static/media/bug.396d5870.svg";